import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=2a272173&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=2a272173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a272173",
  null
  
)

export default component.exports